// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import store from './store'

import md5 from 'js-md5'
Vue.prototype.$md5 = md5
Vue.prototype.$file_max_size = 1 * 500 * 1024;
Vue.prototype.$file_max_size_text = "请确保图片大小在500k以内"

// 高德离线地图
// 高德离线地图
import VueAMap from 'vue-amap';
Vue.use(VueAMap);

VueAMap.initAMapApiLoader({
  // 高德key
  key: '4e20e257ab920bccdfe5ea59f99fd2c1', // 自己到官网申请 申请的什么类型的
  // 插件集合 （插件按需引入）
  plugin: ['AMap.PlaceSearch','AMap.AutoComplete', "AMap.Geolocation", "AMap.Geocoder", "AMap.ToolBar", "AMap.Scale"],
  v: '1.4.15',
  uiVersion: '1.0.11' // ui版本号，也是需要写，不配置不加载,

})

import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
Vue.use(VueQuillEditor);

// 引入axios
import axios from 'axios'
Vue.prototype.$axios = axios
axios.defaults.withCredentials = true
import store from './store'

import '@/api/mockApi.js'

import qs from 'qs'
Vue.prototype.$Qs = qs

Vue.prototype.$bus = new Vue()

// excel导出插件
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
import ECharts from 'vue-echarts'
Vue.component('v-chart', ECharts)

import moment from 'moment'
Vue.prototype.$moment = moment

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.prototype.$cookies = VueCookies

import App from './App'
import router from './router'
import Button from 'ant-design-vue/lib/button'
import 'ant-design-vue/dist/antd.css'
// import { Form, Input, Select } from 'ant-design-vue';
import { FormModel } from 'ant-design-vue';
import Antd from 'ant-design-vue';
import ProtocolRules from '@/components/ProtocolRules.vue';


Vue.use(Antd)
Vue.use(FormModel);
Vue.component(Button.name, Button)
Vue.component('ProtocolRules', ProtocolRules)

Vue.config.productionTip = false
Vue.prototype.topage = function (routerpath) {
  this.$router.push(routerpath);
}

// 路由守卫
router.beforeEach((to, from, next) => {
  // 如果设置了标题, 则设置为页面的标题
  if (to.meta.title) {
    document.title = to.meta.title; // 设置标题
  }
  // 这里调用getToken是为了防止我们页面刷新后vueX丢失token信息
  // store.commit("getToken");
  const token = sessionStorage.getItem('user_token');
  // 如果当前token为空并且当前页(to)不等于登录页
  if (!token && to.name !== "login") {
    next({ name: "login" });
  } else if (token && to.name === "login") {
    next({ name: "home" });
  } else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

export default Vue



// WEBPACK FOOTER //
// ./src/main.js